import { useClans, useMyClanId } from "@/entities/clans";
import { Button } from "@/shared/ui/button";
import { Label } from "@/shared/ui/label";
import { Modal } from "@/shared/ui/Modal";

export const SeeClanContactsModal = () => {
  const clanId = useMyClanId();

  const { data: clan } = useClans(
    {
      currentPage: 1,
      pageSize: 1,
      ids: [clanId ?? ""],
    },
    { enabled: !!clanId },
  );

  const contacts = clan?.data[0].contact;

  return (
    <Modal>
      <Modal.Trigger variant="outline" asChild>
        <div>
          <Label className={`text-sm font-normal md:text-[12px]`}>
            Связь с лидером клана
          </Label>
          <Button variant="outline" className="w-full text-textColor">
            Открыть контакты
          </Button>
        </div>
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Контакты лидера клана</Modal.Title>
        <div className="flex justify-between">
          <p className="font-semibold">Основной</p>
          <p>{contacts?.main ?? "N/A"}</p>
        </div>
        <div className="flex justify-between">
          <p className="font-semibold">Резервный</p>
          <p>{contacts?.reserve ?? "N/A"}</p>
        </div>
        <Modal.Close />
      </Modal.Content>
    </Modal>
  );
};
